module.exports = __webpack_public_path__ + "img/文山州人民医院.d82eecfa.png";